//@ts-ignore
import MontserratRegular from './Montserrat/Montserrat-Regular.ttf';
//@ts-ignore
import MontserratLight from './Montserrat/Montserrat-Light.ttf';
//@ts-ignore
import MontserratMedium from './Montserrat/Montserrat-Medium.ttf';
//@ts-ignore
import MontserratSemiBold from './Montserrat/Montserrat-SemiBold.ttf';
//@ts-ignore
import MontserratBold from './Montserrat/Montserrat-Bold.ttf';

//@ts-ignore
import GeistVariable from './geist/Geist-VariableFont_wght.ttf';
//@ts-ignore
import InstrumentSerifRegular from './instrumentSerif/InstrumentSerif-Regular.ttf';
//@ts-ignore
import InstrumentSerifItalic from './instrumentSerif/InstrumentSerif-Italic.ttf';

const Fonts = {
  MontserratRegular,
  MontserratLight,
  MontserratMedium,
  MontserratSemiBold,
  MontserratBold,
  GeistVariable,
  InstrumentSerifRegular,
  InstrumentSerifItalic,
};

export default Fonts;
